import {Box, Typography} from '@mui/material';
import {
  statsBox,
  statCardBookingRate,
  statCardRevenueChange,
  estimatedRevenueTextStyle,
  percentageText,
  bookingRateLabel,
  bookingRatePercentageTextStyle,
} from './styles';
import {Color} from '~/constants/style';

interface ExpandedMonthlyRevenueStatsProps {
  bookingRate: number;
  estimatedRevenue: number;
  isFuture: boolean;
}

const ExpandedMonthlyRevenueStats: React.FC<
  ExpandedMonthlyRevenueStatsProps
> = ({bookingRate, estimatedRevenue, isFuture}) => (
  <Box sx={statsBox}>
    <Box sx={statCardBookingRate}>
      <Typography variant="body2" sx={bookingRateLabel}>
        Booking rate
      </Typography>
      <Typography variant="h5" sx={bookingRatePercentageTextStyle}>
        {bookingRate}%
      </Typography>
    </Box>
    <Box sx={statCardRevenueChange}>
      <Typography variant="body2" sx={estimatedRevenueTextStyle}>
        {isFuture
          ? 'Estimated revenue since last month'
          : 'Revenue since last month'}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          ...percentageText,
          color: estimatedRevenue < 0 ? Color.ErrorMain : Color.SuccessMain,
        }}
      >
        {estimatedRevenue.toLocaleString()}%
      </Typography>
    </Box>
  </Box>
);

export default ExpandedMonthlyRevenueStats;
